var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.wW=require("crc-32");module.exports=$CLJS.wW;